import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-locations-dashboard',
  templateUrl: './turns-locations-dashboard.component.html',
  styleUrls: ['./turns-locations-dashboard.component.scss']
})
export class TurnsLocationsDashboardComponent implements OnInit {

  locations;
  filterKey;
  filterOpts;
  noItemsConfig;
  viewDisposition = 'grid';
  getLocationsSubscription: Subscription;
  refreshLocationsListenSubscription: Subscription;
  searchLocationsSubscription: Subscription;
  filterLocationsSubscription: Subscription;
  locationsTurnsDispositionSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private locationsTurnsService: LocationsTurnsService,
              private cd: ChangeDetectorRef,
              private snackbarService: SnackBarService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getLocations();
    this.refreshLocationsListenSubscription = this.locationsTurnsService.refreshLocationsListen().subscribe(
      (res) => {
        this.getLocations();
      }
    );
    this.filterLocationsSubscription = this.locationsTurnsService.filterLocationsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchLocationsSubscription = this.locationsTurnsService.searchLocationsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.locationsTurnsDispositionSubscription = this.locationsTurnsService.toggleLocationsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getLocations() {
    this.getLocationsSubscription = this.locationsTurnsService.getLocationList().subscribe(
      (res) => {
        this.locations = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-map-marker-alt', 'turns-page.locations', '/turns/parameters', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.parameters', '/turns/parameters'), new BRoute('turns-page.locations')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'turns-page.locations not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngDestroy() {
    if (this.getLocationsSubscription) { this.getLocationsSubscription.unsubscribe(); }
    if (this.refreshLocationsListenSubscription) { this.refreshLocationsListenSubscription.unsubscribe(); }
    if (this.searchLocationsSubscription) { this.searchLocationsSubscription.unsubscribe(); }
    if (this.filterLocationsSubscription) { this.filterLocationsSubscription.unsubscribe(); }
  }
}
